import { useState, useCallback } from "react";
import { Cafe } from "../../../../api/types";

interface UseFranchiseModalReturn {
  // 모달 상태
  showMoreOption: boolean;
  selectedStore: Cafe | null;

  // 모달 제어 함수
  openMoreOption: (cafe: Cafe) => void;
  closeMoreOption: () => void;
  toggleMoreOption: (cafe?: Cafe) => void;
}

export const useFranchiseModal = (): UseFranchiseModalReturn => {
  const [showMoreOption, setShowMoreOption] = useState<boolean>(false);
  const [selectedStore, setSelectedStore] = useState<Cafe | null>(null);

  // 모달 열기
  const openMoreOption = useCallback((cafe: Cafe) => {
    setSelectedStore(cafe);
    setShowMoreOption(true);
  }, []);

  // 모달 닫기
  const closeMoreOption = useCallback(() => {
    setShowMoreOption(false);
    setSelectedStore(null);
  }, []);

  // 모달 토글 (열려있으면 닫고, 닫혀있으면 카페 정보와 함께 열기)
  const toggleMoreOption = useCallback(
    (cafe?: Cafe) => {
      if (showMoreOption) {
        closeMoreOption();
      } else if (cafe) {
        openMoreOption(cafe);
      }
    },
    [showMoreOption, closeMoreOption, openMoreOption]
  );

  return {
    // 모달 상태
    showMoreOption,
    selectedStore,

    // 모달 제어 함수
    openMoreOption,
    closeMoreOption,
    toggleMoreOption,
  };
};
